// extracted by mini-css-extract-plugin
module.exports = {"colorFontPrimary":"#333","colorFontLinkHighlight":"#ff3267","easeOutExpo":"cubic-bezier(.19,1,.22,1)","component":"_2SY3b85GtpiMtGxIrciC6K","isHidden":"_2ZaIVhKnVtv8yWn82fOcun"};